// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_ZUb4A","footer":"index_footer_WG4nh"};